import type { GraphQLError } from 'graphql';

import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';

import PersistentInviteEligibleQuery from './__generated__/PersistentInviteEligibleQuery.graphql.ts';
import type {
	PersistentInviteEligibleQuery as PersistentInviteEligibleQueryType,
	PersistentInviteEligibleQueryVariables,
} from './__types__/PersistentInviteEligibleQuery.ts';

export async function preloadPersistentInviteButtonEligible(
	{
		spaceKey,
	}: {
		spaceKey?: string;
	},
	skipSpaceQuery: boolean = false,
): Promise<{
	data: PersistentInviteEligibleQueryType | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	const { edition, isLicensed, userId } = getPreloaderFnContext();

	const isFreeEdition = edition === ConfluenceEdition.FREE;

	return query<PersistentInviteEligibleQueryType, PersistentInviteEligibleQueryVariables>({
		query: PersistentInviteEligibleQuery,
		variables: {
			spaceKey,
			skipLicenseQuery: isFreeEdition || !isLicensed || !userId || skipSpaceQuery,
			skipSpaceQuery: !spaceKey,
		},
	});
}
